var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechPattern1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 488.98 158.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-15,.cls-18,.cls-2,.cls-22,.cls-24,.cls-25,.cls-27,.cls-29,.cls-4,.cls-6,.cls-8{opacity:0.5;}.cls-2{fill:url(#linear-gradient);}.cls-16,.cls-17,.cls-19,.cls-23,.cls-28,.cls-3,.cls-7{opacity:0.2;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-14,.cls-20,.cls-21,.cls-26,.cls-30,.cls-31,.cls-5,.cls-9{opacity:0.35;}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-15);}.cls-17{fill:url(#linear-gradient-16);}.cls-18{fill:url(#linear-gradient-17);}.cls-19{fill:url(#linear-gradient-18);}.cls-20{fill:url(#linear-gradient-19);}.cls-21{fill:url(#linear-gradient-20);}.cls-22{fill:url(#linear-gradient-21);}.cls-23{fill:url(#linear-gradient-22);}.cls-24{fill:url(#linear-gradient-23);}.cls-25{fill:url(#linear-gradient-24);}.cls-26{fill:url(#linear-gradient-25);}.cls-27{fill:url(#linear-gradient-26);}.cls-28{fill:url(#linear-gradient-27);}.cls-29{fill:url(#linear-gradient-28);}.cls-30{fill:url(#linear-gradient-29);}.cls-31{fill:url(#linear-gradient-30);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5810.55,
    y1: -6144.01,
    x2: -5778.36,
    y2: -6111.82,
    gradientTransform: "translate(-5603.32 -6104.35) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f2f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e8e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -5981.27,
    y1: -6144.01,
    x2: -5949.09,
    y2: -6111.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6066.64,
    y1: -6217.96,
    x2: -6034.45,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -6023.96,
    y1: -6217.96,
    x2: -5991.77,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -5938.59,
    y1: -6217.96,
    x2: -5906.4,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -5853.23,
    y1: -6217.96,
    x2: -5821.04,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -5810.55,
    y1: -6217.96,
    x2: -5778.36,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -5767.86,
    y1: -6217.96,
    x2: -5735.67,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -5725.18,
    y1: -6217.96,
    x2: -5692.99,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -6087.98,
    y1: -6180.97,
    x2: -6055.79,
    y2: -6148.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -6045.3,
    y1: -6180.97,
    x2: -6013.11,
    y2: -6148.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -6002.61,
    y1: -6180.97,
    x2: -5970.43,
    y2: -6148.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -5959.93,
    y1: -6180.97,
    x2: -5927.74,
    y2: -6148.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -5874.57,
    y1: -6180.97,
    x2: -5842.38,
    y2: -6148.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -5831.89,
    y1: -6180.97,
    x2: -5799.7,
    y2: -6148.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -5746.52,
    y1: -6180.97,
    x2: -5714.33,
    y2: -6148.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -5703.84,
    y1: -6180.97,
    x2: -5671.65,
    y2: -6148.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -5981.27,
    y1: -6217.96,
    x2: -5949.09,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -5639.82,
    y1: -6217.96,
    x2: -5607.63,
    y2: -6185.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -5917.25,
    y1: -6180.97,
    x2: -5885.06,
    y2: -6148.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -6087.98,
    y1: -6254.92,
    x2: -6055.79,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -6045.3,
    y1: -6254.92,
    x2: -6013.11,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -6002.61,
    y1: -6254.92,
    x2: -5970.43,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -5959.93,
    y1: -6254.92,
    x2: -5927.74,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -5874.57,
    y1: -6254.92,
    x2: -5842.38,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -5831.89,
    y1: -6254.92,
    x2: -5799.7,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -5703.84,
    y1: -6254.92,
    x2: -5671.65,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -5661.16,
    y1: -6254.92,
    x2: -5628.97,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -5917.25,
    y1: -6254.92,
    x2: -5885.06,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -5789.2,
    y1: -6254.92,
    x2: -5757.02,
    y2: -6222.74,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ex_2",
    "data-name": "ex 2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "170.73 35.35 170.73 11.78 191.13 0 211.54 11.78 211.54 35.35 191.13 47.13 170.73 35.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "341.46 35.35 341.46 11.78 361.86 0 382.27 11.78 382.27 35.35 361.86 47.13 341.46 35.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "426.82 109.3 426.82 85.73 447.23 73.95 467.63 85.73 467.63 109.3 447.23 121.08 426.82 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "384.14 109.3 384.14 85.73 404.55 73.95 424.95 85.73 424.95 109.3 404.55 121.08 384.14 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "298.77 109.3 298.77 85.73 319.18 73.95 339.59 85.73 339.59 109.3 319.18 121.08 298.77 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "213.41 109.3 213.41 85.73 233.82 73.95 254.22 85.73 254.22 109.3 233.82 121.08 213.41 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "170.73 109.3 170.73 85.73 191.13 73.95 211.54 85.73 211.54 109.3 191.13 121.08 170.73 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "128.05 109.3 128.05 85.73 148.45 73.95 168.86 85.73 168.86 109.3 148.45 121.08 128.05 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "85.36 109.3 85.36 85.73 105.77 73.95 126.18 85.73 126.18 109.3 105.77 121.08 85.36 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "448.16 72.31 448.16 48.75 468.57 36.96 488.98 48.75 488.98 72.31 468.57 84.09 448.16 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "405.48 72.31 405.48 48.75 425.89 36.96 446.29 48.75 446.29 72.31 425.89 84.09 405.48 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "362.8 72.31 362.8 48.75 383.2 36.96 403.61 48.75 403.61 72.31 383.2 84.09 362.8 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "320.12 72.31 320.12 48.75 340.52 36.96 360.93 48.75 360.93 72.31 340.52 84.09 320.12 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "234.75 72.31 234.75 48.75 255.16 36.96 275.56 48.75 275.56 72.31 255.16 84.09 234.75 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.07 72.31 192.07 48.75 212.48 36.96 232.88 48.75 232.88 72.31 212.48 84.09 192.07 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "106.71 72.31 106.71 48.75 127.11 36.96 147.52 48.75 147.52 72.31 127.11 84.09 106.71 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "64.02 72.31 64.02 48.75 84.43 36.96 104.84 48.75 104.84 72.31 84.43 84.09 64.02 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "341.46 109.3 341.46 85.73 361.86 73.95 382.27 85.73 382.27 109.3 361.86 121.08 341.46 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "0 109.3 0 85.73 20.41 73.95 40.81 85.73 40.81 109.3 20.41 121.08 0 109.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "277.43 72.31 277.43 48.75 297.84 36.96 318.25 48.75 318.25 72.31 297.84 84.09 277.43 72.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "448.16 146.26 448.16 122.7 468.57 110.92 488.98 122.7 488.98 146.26 468.57 158.04 448.16 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "405.48 146.26 405.48 122.7 425.89 110.92 446.29 122.7 446.29 146.26 425.89 158.04 405.48 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "362.8 146.26 362.8 122.7 383.2 110.92 403.61 122.7 403.61 146.26 383.2 158.04 362.8 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "320.12 146.26 320.12 122.7 340.52 110.92 360.93 122.7 360.93 146.26 340.52 158.04 320.12 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "234.75 146.26 234.75 122.7 255.16 110.92 275.56 122.7 275.56 146.26 255.16 158.04 234.75 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "192.07 146.26 192.07 122.7 212.48 110.92 232.88 122.7 232.88 146.26 212.48 158.04 192.07 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "64.02 146.26 64.02 122.7 84.43 110.92 104.84 122.7 104.84 146.26 84.43 158.04 64.02 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "21.34 146.26 21.34 122.7 41.75 110.92 62.16 122.7 62.16 146.26 41.75 158.04 21.34 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "277.43 146.26 277.43 122.7 297.84 110.92 318.25 122.7 318.25 146.26 297.84 158.04 277.43 146.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "149.39 146.26 149.39 122.7 169.79 110.92 190.2 122.7 190.2 146.26 169.79 158.04 149.39 146.26"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechPattern1);
export default __webpack_public_path__ + "static/media/tech-pattern-1.d726a197260c9940d4dad7161b0cefc9.svg";
export { ForwardRef as ReactComponent };